import React, { useState } from 'react';
import { Container } from './Styled';

interface EmailContainerProps {
    fullName: string;
    setFullName: (fullName: string) => void;
    isNameValid: (fullName: string) => boolean;
}


const FullNameContainer = ({ fullName, setFullName, isNameValid }: EmailContainerProps) => {
    const [errorMessage, setErrorMessage] = useState("")

    const checkValidity = () => {
        if (! fullName) {
            setErrorMessage("Enter your full name to continue")
        } else if (! isNameValid(fullName)) {
            setErrorMessage("Name field must contain letters only")
    
        } else {
            setErrorMessage("")
        }
    }
    return (
        <div style={{fontFamily: "Inter, sans-serif", fontSize: "14px", paddingTop:'15px'}}>
            Full Name
            <Container>
                <input
                    type='text'
                    aria-label="Enter your full name"
                    id="fullName"
                    onChange={(e: any) => {
                        setFullName(e.target.value);
                    }}
                    value={fullName}
                    required
                    className="custom-input"
                    onBlur={() => checkValidity()}
                />
                <div className={`validation-error ${errorMessage ? '' : 'hidden'}`}>
                    {errorMessage}
                </div>
            </Container>
        </div>
    );
}

export default FullNameContainer;